export const chatFiltersNames = [
    {
        label:"All",
        value:"all",
    },
    {
        label:"Waiting",
        value:'waiting',
    },
    {
        label:"Replied",
        value:'replied',
    },
    {
        label:"Ongoing",
        value:'ongoing',
    },
   
    {
        label:"Dormant",
        value:'dormant',
    },
]
